var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5ZM9.86461 14.5V7.318H8.13561V14.5H9.86461ZM10.0326 5.645C10.0933 5.51433 10.1236 5.37433 10.1236 5.225C10.1236 5.071 10.0933 4.92633 10.0326 4.791C9.97194 4.65567 9.89028 4.539 9.78761 4.441C9.68961 4.343 9.57294 4.266 9.43761 4.21C9.30228 4.14933 9.15761 4.119 9.00361 4.119C8.85428 4.119 8.71194 4.14933 8.57661 4.21C8.44594 4.266 8.33161 4.343 8.23361 4.441C8.13561 4.539 8.05628 4.65567 7.99561 4.791C7.93961 4.92633 7.91161 5.071 7.91161 5.225C7.91161 5.37433 7.93961 5.51433 7.99561 5.645C8.05628 5.77567 8.13561 5.89 8.23361 5.988C8.33161 6.086 8.44594 6.16533 8.57661 6.226C8.71194 6.282 8.85428 6.31 9.00361 6.31C9.15761 6.31 9.30228 6.282 9.43761 6.226C9.57294 6.16533 9.68961 6.086 9.78761 5.988C9.89028 5.89 9.97194 5.77567 10.0326 5.645Z",
    fill: "#ff6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleIcon);
export default __webpack_public_path__ + "static/media/info-circle-icon.4fae1175604582cd95e4b75c3679c511.svg";
export { ForwardRef as ReactComponent };